import {useState} from "react";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Box from '@material-ui/core/Box';
import MessaggioInviato from "../MessaggioInviatoDialog/MessaggioInviato";
import ButtonIconLeft from "../../../../../ui/buttons/button-icon-left/ButtonIconLeft";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";
import * as actions from "../../../../../../store";
import {useDispatch, useSelector} from "react-redux";

const useStyles = makeStyles({
    titleClasses: {
        '& > *': {
            marginBottom: "2em"
        }
    }
});

const AltereComunicazioniContent = (props) => {
    const classes = useStyles();
    const [openMessaggioInviato, setOpenMessaggioInviato] = useState(false);
    const [messageText, setMessageText] = useState('');
    const userClaims = useSelector(state => state.authReducer.userClaims);
    const selectedCompany = useSelector(state => state.authReducer.selectedCompany);
    const loadingReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.loading);
    const errorReportProblem = useSelector(state => state.serviceRequestReducer.reportProblem.error);
    const dispatch = useDispatch();


    const inputChanged = (event) => {
        setMessageText(event.target.value);
    };

    const handleOpenMessaggioInviato = () => {
        dispatch(actions.submitReportInSegnalazione(selectedCompany.integrationId,
            selectedCompany.livelloDiAssistenzaId,
            props.screenCode, userClaims.uid,
            "", "", "", messageText, "", [], messageText));
        setOpenMessaggioInviato(true);
    };

    const handleDialogClose = () => {
        setOpenMessaggioInviato(false);
        props.handleDialogClose();
    }

    const dialogContent = (
        <>
            <Grid item xs={12} sm={12} md={10}>
                <Typography variant="body2">
                    Puoi contattare il Servizio Clienti Fastweb per tutte le richieste di informazioni o di contatto di
                    cui hai bisogno.
                    Sarai ricontattato quanto prima.
                </Typography>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12} md={3}>
                    <Typography component="div">
                        <Box fontWeight="fontWeightBold">
                            Messaggio
                        </Box>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={9}>
                    <TextField
                        rows={8}
                        className="w-100 mb-8"
                        onChange={inputChanged}
                        onPaste={inputChanged}
                        value={messageText}
                        label="Descrivi qui il tuo messaggio"
                        multiline
                        variant="outlined"
                    /> </Grid>
            </Grid>
            {openMessaggioInviato && !loadingReportProblem && !errorReportProblem ? (
                <MessaggioInviato
                    open={openMessaggioInviato}
                    handleDialogClose={handleDialogClose}
                    handleMessaggioInviatoCloseButton={() => setOpenMessaggioInviato(false)}
                />
            ) : null}
        </>
    );

    const dialogActions = (
        <Grid container justifyContent="space-between">
            <Button onClick={props.handleDialogClose} color="primary" variant="outlined">
                <div className="align-center-x px-16">Annulla</div>
            </Button>

            <Button color="primary" variant="contained" disabled={messageText.length === 0}
                    onClick={handleOpenMessaggioInviato}>
                <div className="align-center-x px-16">Invia</div>
            </Button>
        </Grid>
    );

    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleAltereComunicazioniCloseButton}
            dialogActions={dialogActions}
            dialogContent={dialogContent}
        >
            <div className={classes.titleClasses}>
                <ButtonIconLeft
                    title={"Indietro"}
                    handleClick={props.handleDialogClose}
                    icon={<ArrowBackIosIcon fontSize="small"/>}/>
                <Typography variant={"h5"}>Altre comunicazioni</Typography>
            </div>
        </GenericDialog>
    )
}

AltereComunicazioniContent.propTypes = {
    handleDialogClose: PropTypes.func,
    handleAltereComunicazioniCloseButton: PropTypes.func,
    open: PropTypes.bool,
    screenCode: PropTypes.string
};


export default AltereComunicazioniContent;
